// TODO: Import React module
import React, { useState, useEffect, } from 'react';

// TODO: Import MUI module
import { Box, Container, ImageList, ImageListItem, ImageListItemBar, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// TODO: Import MUI icon
import { } from '@mui/icons-material';

// TODO: Import context
import { Context, WebservicesYiYuan } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component

const Knowledge = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component Knowledge Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const cols = isXs ? 1 : isSm ? 2 : isMd ? 2 : 3;

    const [images, setImages] = useState([]);

    // TODO: Define event
    const getKnowledge = () => {
        (async () => {
            const formData = new FormData();
            formData.append('action', 'GetKnowledge');

            fetch(WebservicesYiYuan, { method: 'POST', body: formData, })
                .then((response) => response.json())
                .then((result) => {
                    if (result.length > 0) {
                        setImages(result);
                    }
                })
                .catch((error) => { console.error('Error:', error); });
        })();
    }

    const handleClickOpen = (url) => {
        window.open(url, '_blank');
    };

    useEffect(getKnowledge, []);

    // TODO: Return component
    return (
        <Box id="Knowledge" sx={{ py: 4, }}>
            <Container>
                <Typography
                    align="center"
                    gutterBottom
                    sx={{ color: 'success.dark', fontWeight: 'bold', textAlign: 'center', }}
                    variant="h4"
                >
                    {Text.CampusDevelopment.BlessedBotanicals.Knowledge.Title[language]}
                </Typography>
                <ImageList cols={cols} gap={16} sx={{ gridAutoRows: '240px', }}>
                    {images.map((image) => (
                        <ImageListItem
                            key={image.URL}
                            onClick={() => handleClickOpen(image.URL)}
                            sx={{
                                '&:hover img': {
                                    filter: 'brightness(1.3)',
                                    transition: 'all 0.3s ease',
                                },
                                cursor: 'pointer',
                            }}
                        >
                            <img
                                src={`https://www.pohtyh.edu.hk/YiYuan/images/knowledge/${image.Image}`}
                                alt={image.Title}
                                loading="lazy"
                                style={{ borderRadius: 16, width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                            <ImageListItemBar
                                sx={{ borderBottomLeftRadius: 16, borderBottomRightRadius: 16 }}
                                title={image.Title}
                            />
                        </ImageListItem>
                    ))}
                </ImageList>
            </Container>
        </Box>
    );
};

export default Knowledge;